memoFn